import React from "react";
import { observer } from "mobx-react";
import SparkleIcon from "Components/common/SparkleIcon";
import BlockRenderer from "./BlockRenderer";
import ComposingHint from "./ComposingHint";

/**
 * True once something has rendered but the closing text has not arrived yet.
 * A text block that is still empty counts as "not arrived".
 */
const awaitingProse = message => {
  const blocks = message.blocks || [];
  if (!blocks.length) return false;
  const last = blocks[blocks.length - 1];
  return last.type !== "text" || !(last.markdown || "").trim();
};

const MessageRow = observer(({ message }) => {
  if (message.role === "user") {
    return (
      <div className="copilotMsg copilotMsg--user">
        <div className="copilotMsg__userCol">
          <div
            className="copilotMsg__bubble"
            style={message.queued ? { opacity: 0.6 } : undefined}
          >
            {message.text}
          </div>
          {message.queued && (
            <div className="copilotMsg__queuedHint">
              Queued — sending after the current response
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="copilotMsg copilotMsg--assistant">
      <div className="copilotMsg__avatar">
        <SparkleIcon />
      </div>
      <div className="copilotMsg__content">
        {(message.blocks || []).map((block, index) => (
          <BlockRenderer
            key={block.id}
            block={block}
            isStreaming={
              message.streaming && index === message.blocks.length - 1
            }
          />
        ))}
        {/* Thumbs feedback removed on request. copilotStore.sendFeedback and
            the server's /copilot/feedback JSONL sink are still in place if it
            comes back. */}
        {message.streaming && !(message.blocks || []).length && (
          <div className="copilotMsg__pending">
            <span className="copilotDot" />
            <span className="copilotDot" />
            <span className="copilotDot" />
          </div>
        )}
        {/* Blocks have landed but the answer is still being written — without
            this the turn looks finished and silent. */}
        {message.streaming && awaitingProse(message) && <ComposingHint />}
      </div>
    </div>
  );
});

export default MessageRow;
